import { app } from "../App";
import { ContestWithId } from "../interfaces/IContests";
import { findContestsSnapshot } from "../utils/firestore";
import { getAuth } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";
import { useEffect, useState } from "react";

export const useContests = () => {
  const [contests, setContests] = useState<ContestWithId[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [loggedUserAuth, authLoading] = useAuthState(getAuth(app));

  useEffect(() => {
    // BEZPIECZEŃSTWO: Sprawdź czy użytkownik jest zalogowany przed wywołaniem onSnapshot
    // onSnapshot wymaga request.auth != null w Firestore rules
    if (authLoading) {
      // Czekaj na zakończenie sprawdzania autentykacji
      return;
    }
    
    if (!loggedUserAuth) {
      // Jeśli użytkownik nie jest zalogowany, nie pobieraj danych
      setContests([]);
      setIsLoading(false);
      return;
    }

    // NOWA IMPLEMENTACJA - onSnapshot (tylko gdy użytkownik jest zalogowany)
    setIsLoading(true);
    const unsubscribe = findContestsSnapshot((contestsData) => {
      setContests(contestsData as ContestWithId[]);
      setIsLoading(false);
    });

    // Cleanup - odsubskrybowanie przy unmount
    return () => {
      unsubscribe();
    };
  }, [loggedUserAuth, authLoading]);

  return { contests, isLoading };
};
